import { useNavigate } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

const Topbar = ({ title, onMenuClick }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center justify-between border-b border-[#e4d9c8] bg-white px-4 sm:px-6 lg:px-8">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onMenuClick}
          className="!bg-transparent !p-1.5 !text-[#130705] !shadow-none hover:!bg-transparent hover:!shadow-none lg:hidden"
          aria-label="Open menu"
        >
          <FiMenu className="h-5 w-5" />
        </button>
        <h1 className="font-[Merriweather] text-base text-[#130705] sm:text-[17px]">
          {title}
        </h1>
      </div>

      <div className="flex items-center gap-3">
        <div className="hidden items-center gap-2.5 sm:flex">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#f5f1ea] text-[12px] font-semibold text-[#785E32]">
            {(user?.username || 'A').charAt(0).toUpperCase()}
          </div>
          <div className="leading-tight">
            <p className="text-[13px] font-medium text-[#130705]">
              {user?.username}
            </p>
            <p className="text-[11px] capitalize text-[#8d7045]">
              {user?.role || 'Admin'}
            </p>
          </div>
        </div>

        <div className="hidden h-5 w-px bg-[#e4d9c8] sm:block" />

        <button
          type="button"
          onClick={handleLogout}
          className="rounded-md !border !border-[#e4d9c8] !bg-white !px-3 !py-1.5 text-[13px] font-medium !text-[#130705] !shadow-none hover:!bg-[#faf8f4] hover:!shadow-none"
        >
          Log out
        </button>
      </div>
    </header>
  );
};

export default Topbar;
